import React, { useMemo, useRef, useState } from "react";
import download from "downloadjs";
import { ReportRows } from "./ReportRows";
import { Trans, useTranslation } from "react-i18next";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,Table
} from "reactstrap";
import { useXeroClient } from "../../../../hooks";
import { useProcessReport } from "./util";

export const ReportContainer = ({ report: reportProp, actions }) => {
  const ref = useRef();
  const client = useXeroClient();
  const [pending, setPending] = useState(false);
  const processReport = useProcessReport();
  const { t } = useTranslation();

  const report = useMemo(
    () => processReport(reportProp),
    [processReport, reportProp, t]
  );
  const { ReportTitles, Rows } = report;
  const [title] = ReportTitles;

  const onExport = (format) => async () => {
    setPending(true);
    const filename = `${title}.${format}`;

    try {
      if (format === "pdf") {
        const { content } = await client
          .post("all/generate_document", {
            template: `<div style="font-size: 20px">${ref.current.innerHTML}</div>`,
            filename,
          })
          .get("data");
        download(content, filename);
      } else if (format === "csv" || format === "xlsx") {
        const { data } = await client
          .post("all/convert_report", {
            format,
            data: report,
          })
          .get("data");
        download(data, filename);
      }
    } finally {
      setPending(false);
    }
  };

  return (
    <div>
      <div ref={ref} className="mt-3">
        {ReportTitles.map((i, idx) => (
          <div key={i} style={(idx === 0 ? {fontSize:"1.6em", marginBottom:"0.5em"} : {})}>{i}</div>
        ))}
        {/* aeddin update tabele to Table */}
        <Table className="table table-sm small mt-3" responsive>
          <tbody>
            <ReportRows rows={Rows} />
          </tbody>
        </Table>
      </div>
      <div className="tw-flex tw-space-x-2 Bnk-Sry-table">
        {actions}
        <UncontrolledDropdown>
          <DropdownToggle disabled={pending} color="primary" caret>
            <span className="ml-1">
              {pending ? <span className="fa fa-spin fa-spinner mr-2" /> : ""}
              <Trans>Export</Trans>
            </span>
          </DropdownToggle>
          <DropdownMenu>
            {/* <DropdownItem onClick={onExport("csv")}>
              <Trans>CSV</Trans>
            </DropdownItem> */}
            <DropdownItem onClick={onExport("xlsx")}>
              <Trans>Excel</Trans>
            </DropdownItem>
            <DropdownItem onClick={onExport("pdf")}>
              <Trans>PDF</Trans>
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
    </div>
  );
};
